import React, { useState, useEffect } from 'react';
import ConsultationTypeListMobile from './consultationTypeListMobile';
import ConsultationTypeListWeb from './consultationTypeListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const ConsultationTypeListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <ConsultationTypeListMobile /> : <ConsultationTypeListWeb />;
};

export default ConsultationTypeListRouter;
